import { CategoryType } from './download-enums';

export const DOWNLOAD_CATEGORY_ICONS: Record<string, string> = {
  [CategoryType.IMPRESION]: '',
  [CategoryType.REDES_SOCIALES]: '',
  [CategoryType.AUDIO]: '',
  [CategoryType.VIDEOS]: '',
  [CategoryType.GUIA_MARCA]: '',
  [CategoryType.IMAGENES]: '',
};

export function sortDownloadsNewestFirst<T extends { creationDate: Date | string }>(rows: T[]): T[] {
  return [...rows].sort((a, b) => {
    const tA = new Date(a.creationDate).getTime();
    const tB = new Date(b.creationDate).getTime();
    return tB - tA;
  });
}

/** DD-MM-YYYY (sitio distribuidores) */
export function formatDownloadDateShort(date: Date | string | null | undefined): string {
  if (date == null || date === '') return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  return `${day}-${month}-${d.getFullYear()}`;
}

export function getCategoryIconChar(categoryType: string | undefined): string {
  if (!categoryType) return '';
  return DOWNLOAD_CATEGORY_ICONS[categoryType] ?? '';
}

export function openUrlInNewTab(url: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
